import { render, staticRenderFns } from "./startupProfile.vue?vue&type=template&id=edee4680&scoped=true&"
import script from "./startupProfile.vue?vue&type=script&lang=js&"
export * from "./startupProfile.vue?vue&type=script&lang=js&"
import style0 from "./startupProfile.vue?vue&type=style&index=0&id=edee4680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edee4680",
  null
  
)

export default component.exports